export function modal() {
// すべてのモーダル、開くボタン、閉じるボタンを取得
const modals = document.querySelectorAll('.js-modal');
const openButtons = document.querySelectorAll('.js-modal-open');
const closeButtons = document.querySelectorAll('.js-modal-close');

// 「開くボタン」をクリックしてモーダルを開く
openButtons.forEach((openButton, index) => {
  openButton.addEventListener('click', () => {
    modals[index].classList.add('is-active');
  });
});

// 「閉じるボタン」をクリックしてモーダルを閉じる
closeButtons.forEach((closeButton, index) => {
  closeButton.addEventListener('click', () => {
    modals[index].classList.remove('is-active');
  });
});

// 「モーダルの外側」をクリックしてモーダルを閉じる
modals.forEach((modal) => {
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.classList.remove('is-active');
    }
  });
});
}

